import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * `/admin` is a resolution step, not a page: it forwards to people, the
 * area's first real screen.
 *
 * The segment exists so the sidebar and the breadcrumb have something stable
 * to point at above the area's own pages, the same shape `/files` uses for
 * the same reason (see that route).
 *
 * NO COMPONENT, and the redirect is in `beforeLoad` rather than in a loader
 * for that reason: a route with a component paints it for a frame before the
 * redirect takes effect, which reads as a flash of the wrong screen.
 */
export const Route = createFileRoute('/(private)/(shell)/admin/')({
	beforeLoad: () => {
		throw redirect({ to: '/admin/people' })
	}
})
